/*
 * @Author: liang yuhong
 * @Date:   2018-08-17 10:18:43
 * @Last Modified by:   Ding Jianlong
 * @Last Modified time: 2018-12-04 14:49:33
 */
/*
 * @Author: liang yuhong
 * @Date:   2018-04-25 13:57:18
 * @Last Modified by:   Ding Jianlong
 * @Last Modified time: 2018-05-21 10:37:29
 */
import Vue from 'vue'
import axios from 'axios'
import iView from 'view-design';

Vue.prototype.$ajax = axios
let meetDomain = 'https://api.jxbscbd.com/'
// var meetDomain = 'http://brand.api.ijovo.com/'
// var meetDomain = 'https://jxbscbd.ijovo.com/'
// var meetDomain = 'http://192.168.121.61:8080/'
var api = {}
api.resource = {
  user: {
    getTicket: {
      // url: domain + 'corpTickets/getTicket',
      url: meetDomain + 'gateway/corpChat/corpChat/getTicket',
      type: 'post',
      params: {},
      noUser: true
    },
    getToken: {
      url: meetDomain + 'gateway/corpChat/corpChat/getCommonToken',
      type: 'post',
      params: {},
      noUser: true
    },
    getOrg: {
      url: meetDomain + 'gateway/mdm/admin/inside/tree',
      type: 'get',
      params: {},
    },
    getUsersById: { // 根据id进行模糊搜索，必须6位以上
      url: meetDomain + 'gateway/user/listUserBySearchId',
      type: 'get',
      params: {},
    },
    getManagerById: { // 判断是否为管理员
      url: meetDomain + 'gateway/corpChat/meeting/user/getAuthById',
      type: 'get',
      params: {}
    }
  },
  meet: {
    areas: { // 查询区域列表
      url: meetDomain + 'gateway/corpChat/room/area/list',
      type: 'get',
      params: {},
    },
    listAreaBookRoom: { // 查询 区域下所有房间情况
      url: meetDomain + 'gateway/corpChat/room/book/listAreaBookRoom',
      type: 'get',
      params: {},
    },
    getRoomDetail: { // 获取会议室详情
      url: meetDomain + 'gateway/corpChat/room/room/getRoomDetail',
      type: 'get',
      params: {},
    },
    getRoomBookDetail: { // 获取会议详情以及预定情况
      url: meetDomain + 'gateway/corpChat/room/book/getRoomDetail',
      type: 'get',
      params: {},
    },
    getRoomsByAreaId: { // 获取区域下所有房间
      url: meetDomain + 'gateway/corpChat/room/area/listAllRoom',
      type: 'get',
      params: {},
    },
    getBookRoomsWithUser: { // 获取用户的所有预约
      url: meetDomain + 'gateway/corpChat/room/book/listUserBookRoom',
      type: 'get',
      params: {},
    },
    bookRoom: { // 预约会议室
      url: meetDomain + 'gateway/corpChat/room/book/bookRoom',
      type: 'post',
      params: {},
    },
    addArea: {  // 添加区域
      url: meetDomain + 'gateway/corpChat/room/area/addOrUpdate',
      type: 'post',
      params: {},
    },
    deleteArea: { // 删除区域
      url: meetDomain + 'gateway/corpChat/room/area/delete',
      type: 'post',
      params: {},
    },
    addOrUpdateRoom: { // 增加或修改房间
      url: meetDomain + 'gateway/corpChat/room/room/addOrUpdate',
      type: 'post',
      params: {},
    },
    deleteRoom: { // 删除房间
      url: meetDomain + 'gateway/corpChat/room/room/delete',
      type: 'post',
      params: {},
    },
    getBookRoomDetailByBookId: { // 获取预约详情
      url: meetDomain + 'gateway/corpChat/room/book/getBookRoomDetailByBookId',
      type: 'get',
      params: {}
    },
    cancelBook: { // 取消预约
      url: meetDomain + 'gateway/corpChat/room/book/cancelBook',
      type: 'post',
      params: {}
    }
  }
}
api.send = (obj) => {
  var methods = obj.url.split('.')
  var setting = api.resource[methods[0]][methods[1]]
  var url = setting.url + '?app=Vue'
  if (this.accessToken || api.accessToken) {
    url += '&access_token=' + (this.accessToken || api.accessToken)
  }
  // 默认参数
  if (obj.params === undefined) {
    obj.params = {}
  }
  if (!setting.noUser) {
    if (!JSON.parse(localStorage.getItem('userPermissions'))) {
      iView.Modal.warning({
        title: '提示',
        content: '用户信息失效'
      })
      return
    }
    obj.params.uid = JSON.parse(localStorage.getItem('userPermissions')).userId
    obj.params.uname = JSON.parse(localStorage.getItem('userPermissions')).userName
  }
  for (var index in setting.params) {
    if (obj.params[index] === undefined) {
      obj.params[index] = setting.params[index]
    }
  }
  if (setting.type === 'get') {
    url += '&' + getQueryString(obj.params)
  }
  let jsDada = localStorage.getItem('userPermissions') || '{}'
  jsDada = JSON.parse(jsDada)
  !setting.noHeader && (axios.defaults.headers = { 'Authorization': jsDada.token || '' })
  axios[setting.type](url, obj.params).then(function (response) {
    if (obj.complete && typeof obj.complete === 'function') {
      obj.complete()
    }
    console.log('response', response)
    if (response.data.success) {
      obj.success(response.data.data)
      return this
    } else {
      // 统一的错误处理
      obj.fail && obj.fail(response.data)
      return this
    }
  }).catch(function (error) {
    console.log('报错了')
    console.log(error)
    console.log(error.response)
    if (obj.complete && typeof obj.complete === 'function') {
      obj.complete()
    }
    // // 可写入统一错误处理
    if (obj.fail && typeof obj.fail === 'function') {
      obj.fail(error)
    }
    iView.Modal.error({
      title: '提示',
      content: error.response.data.msg || '发生错误'
    })
  })
}
api.setAccessToken = (token) => {
  this.accessToken = token
}
api.install = (Vue, options) => {
  Vue.prototype.$api = api
  Vue.Api = api
}

function getQueryString (obj) {
  var arr = []
  for (var key in obj) {
    if (typeof obj[key] === 'object') {
      obj[key].forEach((item) => {
        arr.push(key + '[]' + '=' + item)
      })
    } else {
      arr.push(key + '=' + obj[key])
    }
  }
  return arr.join('&')
}
export default api



// WEBPACK FOOTER //
// ./src/plugin/api.js